import React from 'react';
import {sx} from './sx'

import {useTranslation} from 'react-i18next';
import Typography from '@mui/material/Typography';
import {SxType} from "@baseTypes/sx/sxTypes";
import {classNames} from "@helpers/classNames";
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import Paper from '@mui/material/Paper';


interface IProps {
    sx?: SxType
}

const PointsHelperIndicatorMutateSingleVoyage = ({sx: sxProps = {}}: IProps) => {

    const {activePointHelperIndicator} = useRootContextMutateSingleVoyage()

    const {t} = useTranslation()

    return (
        <Paper
            elevation={4}
            sx={{
                ...sx.root,
                ...sxProps
            }}
            className={classNames(activePointHelperIndicator && 'active')}
        >
            <Typography
                sx={sx.name}
            >
                {t('singleVoyage.pointName')}
            </Typography>

            <Typography
                sx={sx.description}
            >
                {t('singleVoyage.nothingData')}
            </Typography>
        </Paper>
    );
};

export default PointsHelperIndicatorMutateSingleVoyage;